import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JeevesAddContactModalComponent } from 'gung-standard-jeeves';
import { CustomerContactService, SelectedCustomerService } from 'gung-standard';

@Component({
    selector: 'colmec-add-contact-modal',
    templateUrl: './colmec-add-contact-modal.component.html',
    styleUrls: ['./colmec-add-contact-modal.component.scss'],
    standalone: false
})
export class ColmecAddContactModalComponent extends JeevesAddContactModalComponent implements OnInit {
  constructor(
    protected formBuilder: FormBuilder,
    protected customerContactService: CustomerContactService,
    protected selectedCustomerService: SelectedCustomerService,
    public activeModal: NgbActiveModal
  ) {
    super(formBuilder, customerContactService, selectedCustomerService, activeModal);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  initForm() {
    this.contactForm = this.formBuilder.group({
      name: this.formBuilder.control(''),
      CS1: this.formBuilder.group({
        comkod: '1',
        comnr: this.formBuilder.control('')
      }),
      CS4: this.formBuilder.group({
        comkod: '4',
        comnr: this.formBuilder.control('')
      }),
      CS8: this.formBuilder.group({
        comkod: '8',
        comnr: this.formBuilder.control('')
      }),
      kp: this.formBuilder.group({
        edit: this.formBuilder.control('')
      })
    });
  }
}
